import React from 'react';
import { Helmet } from 'react-helmet-async';

const KundlistarFAQSchema: React.FC = () => {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'What is Kundlistar?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Kundlistar is an advanced astrology software platform for Vedic, KP, Nadi, BNN, Jaimini, Lal Kitaab, Tajika Varshphal, Muhurat and personalised Gochar analysis.',
        },
      },
      {
        '@type': 'Question',
        name: 'Is Kundlistar available on mobile?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Yes, Kundlistar is available on Android and web. Users can use the same account on both mobile and web.',
        },
      },
      {
        '@type': 'Question',
        name: 'Does Kundlistar support KP astrology?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Yes, Kundlistar supports KP astrology along with Vedic, Nadi, BNN, Jaimini and other astrology systems.',
        },
      },
      {
        '@type': 'Question',
        name: 'Is Kundlistar different from KundliSoft?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Yes, Kundlistar Studio and KundliSoft are different platforms. Kundlistar Studio is available at kundlistarstudio.com and on the App Store.',
        },
      },
    ],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
    </Helmet>
  );
};

export default KundlistarFAQSchema;
